//@ts-nocheck
import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'

import { withSystemConfig } from 'shared'
import FormField from '../../shared/newFormElements'

@withSystemConfig('CashConvRound')
@connect((state, { FormName }) => ({
  rate: formValueSelector(FormName)(state, 'ccyBuyRate'),
  ccySellRate: formValueSelector(FormName)(state, 'ccySellRate'),
  buyAmountA: formValueSelector(FormName)(state, 'buyAmountA'),
  buyACheck: formValueSelector(FormName)(state, 'buyACheck'),
  alreadyDefinedRates: formValueSelector(FormName)(state, 'alreadyDefinedRates'),
  debitCCY: formValueSelector(FormName)(state, 'debitCCY'),
  creditCCY: formValueSelector(FormName)(state, 'creditCCY'),
  sellAmountB: formValueSelector(FormName)(state, 'sellAmountB'),
}))
class BuyAmountA extends React.Component {
  componentDidUpdate(prevProps) {
    const { rate, ccySellRate, alreadyDefinedRates, buyAmountA } = this.props

    if (
      (rate !== prevProps.rate || ccySellRate !== prevProps.ccySellRate) &&
      alreadyDefinedRates === '1' &&
      prevProps.buyACheck === '1' &&
      this.props.creditCCY !== 'GEL'
    ) {
      prevProps.change('sellAmountB', rate ? parseFloat(buyAmountA * parseFloat(rate)).toFixed(15) : 0)
    } else if (
      (rate !== prevProps.rate || ccySellRate !== prevProps.ccySellRate) &&
      alreadyDefinedRates === '1' &&
      prevProps.buyACheck === '1' &&
      this.props.creditCCY === 'GEL'
    ) {
      prevProps.change(
        'sellAmountB',
        rate
          ? Math.round(parseFloat(buyAmountA * parseFloat(rate)).toFixed(15) / prevProps.CashConvRound) *
              prevProps.CashConvRound
          : 0,
      )
    }
  }

  render() {
    const { rate, change, alreadyDefinedRates, disabled, isRequired, OperTypeID, CashConvRound, creditCCY } = this.props

    return (
      <FormField
        type="float"
        maxLength="15"
        disabled={disabled}
        format
        customOnChange={(value) => {
          const parsedValue = parseFloat(value)
          if (OperTypeID === 7 && parseFloat(CashConvRound) > 0.01 && creditCCY === 'GEL') {
            change(
              'sellAmountB',
              parsedValue && rate
                ? Math.round((parsedValue * parseFloat(rate)).toFixed(15) / CashConvRound) * CashConvRound
                : 0,
            )
          } else if (alreadyDefinedRates === '1' && this.props.buyACheck === '1') {
            change('sellAmountB', parsedValue && rate ? (parsedValue * parseFloat(rate)).toFixed(15) : 0)
          }
        }}
        onFocus={() => {
          if (alreadyDefinedRates === '1') {
            change('buyACheck', '1')
            change('sellBCheck', '0')
          }
        }}
        style={{ marginBottom: 5 }}
        name="buyAmountA"
        required={isRequired}
        autoComplete="off"
      />
    )
  }
}

export default BuyAmountA
